'use client';
import { useState, useEffect } from 'react';

import Details from 'components/shared/BaseAccordion/Details';
import Divider from 'components/shared/Divider';
import Summary from 'components/shared/BaseAccordion/Summary';
import RichTextCopy from 'components/shared/RichTextCopy/RichTextCopy';
import { AccordionItemProps } from 'libs/contentful/props';

import { getRichTextValue } from 'utils/formatters';
import { liveUpdateAttrs } from 'libs/contentful/utils';
import { getSectionProps } from '@/utils/styles';
import RichTextHeadline from '../../RichTextHeadline/RichTextHeadline';

const AccordionItem = ({
  sys,
  sectionName,
  accordionLabelRte,
  accordionCopy,
  isFirstElement,
  className,
  showSimpleListStyle,
}: AccordionItemProps) => {
  const [open, setIsOpen] = useState(isFirstElement ?? false);

  const labelText = accordionLabelRte ? String(getRichTextValue(accordionLabelRte)) : '';

  const handleOnClick = (value: boolean) => {
    setIsOpen(value);
  };

  useEffect(() => {
    if (typeof window !== 'undefined' && sectionName != null) {
      setIsOpen(isFirstElement || window.location.hash === `#${sectionName}`);

      window.addEventListener('hashchange', () => {
        if (window.location.hash === `#${sectionName}`) {
          setIsOpen(true);
        }
      });
    }
  }, [isFirstElement, sectionName]);

  return (
    <div {...getSectionProps(undefined, undefined, sectionName)}>
      {!open && <Divider />}
      <Details className={className} open={open}>
        <Summary
          className="max-sm:text-body-saans text-heading-sm cursor-pointer"
          isActive={open}
          label={labelText}
          onClick={handleOnClick}
          {...liveUpdateAttrs(sys?.id, 'accordionLabelRte')}>
          <RichTextHeadline headline={accordionLabelRte} level="h3" />
        </Summary>
        <div className="font-serif text-body-serif pt-6" {...liveUpdateAttrs(sys?.id, 'accordionCopy')}>
          <RichTextCopy copy={accordionCopy} showSimpleListStyle={showSimpleListStyle} />
        </div>
      </Details>
    </div>
  );
};

export default AccordionItem;
